import { Box, Stack } from '@mui/material';

import { Text, colors, isDefined, isTruthy } from 'common';

import { DYNAMIC_PARAMS_FIELD } from './utils';
import { BlockValueTemplateInnerField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

interface RequiredVariableRowProps {
  variableKey: string;
  index: number;
  onFocus: () => void;
}

export function RequiredVariableRow(props: RequiredVariableRowProps) {
  const { variableKey, index, onFocus } = props;
  const fieldName = `${DYNAMIC_PARAMS_FIELD}.${index}.value`;
  const { value, visibleError } = useSelectedNodeField<string>(fieldName);
  const isEmpty = !isTruthy(value);
  return (
    <Stack direction="row" gap={1} alignItems="flex-start" onFocus={() => onFocus()}>
      <Box flex={2} sx={{ paddingTop: 1 }}>
        <Text variant="body2" sx={{ fontFamily: 'monospace' }}>
          {variableKey}
        </Text>
      </Box>
      <Box flex={5}>
        <BlockValueTemplateInnerField
          label={`Value for ${variableKey}`}
          fieldName={fieldName}
          fieldId={fieldName}
          placeholder="Enter value or {{UpstreamBlock.data.field}}"
          required
        />
        <Text
          variant="caption"
          color={
            isDefined(visibleError) || isEmpty ? colors.error.default : colors.extended.gray['45']
          }
        >
          {visibleError ?? 'Required by the selected notification scheme.'}
        </Text>
      </Box>
    </Stack>
  );
}
